import { 
  AwardArea, 
} from '../types/awardarea';
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const AwardAreaApi = appApi.injectEndpoints({
  endpoints: (build) => ({

    getAwardAreas: build.query<any, void>({
      query: () => ({
        url: appEndpoint.awardAreas,
        method: 'get',
      }),
      providesTags: ['AwardAreas'],
    }),
    addAwardArea: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.awardAreas,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["AwardAreas"] : []),
    }),

    updateAwardArea: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.awardAreas}/${data.id}`,
        method: 'put',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["AwardAreas"] : []),
    }),
    

    getAwardAreaById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.awardAreas}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'AwardAreas', id }],
    }),
  
    deleteAwardArea: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.awardAreas}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['AwardAreas'],
    }),

  }),
  overrideExisting: false,
});

// Export hooks for usage in components
export const {
  useGetAwardAreasQuery,
  useGetAwardAreaByIdQuery,
  useDeleteAwardAreaMutation,
  // useGetUnitTypesQuery,
  useUpdateAwardAreaMutation,
  useAddAwardAreaMutation,

} = AwardAreaApi;